import React from 'react';
import PropTypes from 'prop-types';
import Routes from 'apps/portal/routes.erb';
import LayoutHeader from 'shared/layout-header';
import AuthLayout from 'apps/portal/layouts/auth';
import SignUpFormContainer from './components/sign-up-form/container';

const propTypes = {
  gdprEnabled: PropTypes.bool.isRequired,
  identity: PropTypes.shape({
    email: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    phone_number: PropTypes.string,
  }),
};
const defaultProps = {
  identity: undefined,
};

export default function PortalSignUp({ gdprEnabled, identity }) {
  return (
    <AuthLayout
      headerButtons={(
        <LayoutHeader.Button
          href={Routes.new_identity_session_path()}
          theme="text"
        >
          Sign In
        </LayoutHeader.Button>
      )}
      title="Create your free account"
    >
      <SignUpFormContainer
        disableEmailEditing={!!(identity && identity.email)}
        gdprEnabled={gdprEnabled}
        initialValues={identity}
      />
    </AuthLayout>
  );
}

PortalSignUp.propTypes = propTypes;
PortalSignUp.defaultProps = defaultProps;
